export default "__VITE_ASSET__CFQ9Whal__"